module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-profile-c96843f2b6de236821e072a07f05ab4e.svg";